import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { API_URL } from '../../_common/constants';
import { CommonService } from 'src/app/_services/common.service';

@Injectable({
  providedIn: 'root'
})
export class LossControlService {

  constructor(private http: HttpClient, private commonService: CommonService) { }

   // Request to access Loss Control portal
   lossControlPortalAccess():Observable<HttpResponse<any>> {
    return this.http.get<any>(API_URL.LossControlAccessRequestEmail, {observe: 'response'})
        .pipe(map(response => {
            console.log("Loss Control Access Request Sent... ");
            return response;
        }));
}
}
